export default __webpack_public_path__ + "static/media/Asset187.7219ef45.svg";